window.FoxThemePreorder = {
  getVariantMap(productId) {
    const script = document.querySelector(
      `[data-preorder-variant-map][data-product-id="${productId}"]`
    );
    if (!script) return {};

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error(error);
      return {};
    }
  },

  getVariantPreorderData(productId, variantId) {
    const map = this.getVariantMap(productId);
    return map[String(variantId)] || null;
  },

  getButtonText(isPreorder, isAvailable, soldOutText, addToCartText, preorderText) {
    if (!isAvailable) return soldOutText;
    if (isPreorder) return preorderText;
    return addToCartText;
  },

  syncPropertyInput(form, variantData) {
    if (!form) return;

    const input = form.querySelector("[data-preorder-property]");
    if (!input) return;

    if (variantData?.is_preorder && variantData.formatted_date) {
      input.name = "properties[Estimated Shipping Date]";
      input.value = variantData.formatted_date;
      input.disabled = false;
    } else {
      input.disabled = true;
      input.value = "";
    }
  },

  syncButtonFromMain(mainButton, stickyButton) {
    if (!mainButton || !stickyButton) return;

    const mainText = mainButton.querySelector("span:not(.f-icon)");
    const stickyText = stickyButton.querySelector("span:not(.f-icon)");
    if (!mainText || !stickyText) return;

    stickyText.textContent = mainText.textContent.trim();
  },
};
